import { Component, OnInit } from "@angular/core";
import { ApiPartnerService } from "../../api/api-partner.service";
import { ActivatedRoute, Router } from "@angular/router";
import { FormControl, FormBuilder } from "@angular/forms";
import { URLSearchParams } from "@angular/http";
import { LoadJsService } from "../../load-js/load-js.service";

@Component({
  selector: "app-partner-nextsys",
  templateUrl: "./adminnextsys-manage-service.component.html",
  styleUrls: ["./adminnextsys-manage-service.component.css"],
})
export class AdminNextsysManageServiceComponent implements OnInit {
  PartnerList: any = {};
  msearch: string;
  textSearch = new FormControl("");
  workorderList: any = {};
  paging: any = {};
  //paging_link : any = [];
  page_self = [];
  page_next = [];
  page_prev = [];
  last_index: number;
  first_index: number;
  meta = [];
  total_count: number;
  querySearch = false;
  searching = false;
  dataempty = true;
  currentParams = {};
  queryParams = "";
  searchQueryParams = "";
  href = "";

  alert_act = "";
  itemselect: any = [];
  table_load = true;
  alert_success: any = false;
  alert_failed: any = false;
  partnerType: any = [];

  formSelect = this.fb.group({
    partnertype: [""],
    manageby: [""],
    note: [""],
  });

  formAddNewPartner = this.fb.group({
    partnerName: [""],
    billingAddress: [""],
    partnerType: [""],
    manageBy: [""],
    pic: [""],
    phone: [""],
  });

  constructor(
    public partnerService: ApiPartnerService,
    private route: ActivatedRoute,
    public LoadJsOrder: LoadJsService,
    private fb: FormBuilder,
    private router: Router
  ) {}

  ngOnInit() {
    this.loadStart();
  }

  loadStart() {
    this.route.queryParams
      //.filter(params => params.order)
      .subscribe((params) => {
        console.log(params); // {order: "popular"}

        //this.order = params.order;
        //console.log(this.order); // popular

        if (params.search != "" && params.search != undefined) {
          console.log("search");
          console.log(params.search);
          this.msearch = params.search;
          this.querySearch = true;

          this.currentParams = params;
          this.queryParams = "?" + this.queryStr(params);
          this.loadPartner(this.queryParams);
        } else {
          this.querySearch = false;
          this.currentParams = params;

          this.queryParams = "?" + this.queryStr(params);
          console.log(this.queryParams);
          console.log(this.queryStr(params));
          /* pagination */
          //this.loadworkorder(this.currentParams);
          this.loadPartner(this.queryParams);
        }
      });

    this.loadPartnertype();
  }

  loadPartnertype() {
    return this.partnerService.GetPartnertype().subscribe((output: any) => {
      console.log(output);
      this.partnerType = output.data;
    });
  }

  refreshPage() {
    this.ngOnInit();
  }

  clearForm() {
    this.formSelect.reset();
    this.formAddNewPartner.reset();
  }

  queryStr(options: any) {
    let params = new URLSearchParams();
    for (let key in options) {
      params.set(key, options[key]);
    }
    return params.toString();
  }

  cname(item: any) {
    if (item.pairingto == null || item.pairingto == 0) {
      return "-";
    } else {
      return item.customer.nama;
    }
  }

  _services(item: any) {
    let service = "";
    if (item.pairingto == null || item.pairingto == 0) {
      return service;
    } else {
      item.customer.services.forEach(function (value: any) {
        service += value.servicename + "\n";
      });

      return service.replace(/(\\r\\n)|([\r\n])/gim, ", ");
    }
  }

  isPairing(item: any) {
    return item.pairingto > 0 && item.pairingto != null;
  }

  isProvisioning(item: any) {
    return item.provisioningsts == 1;
  }

  isNotProvisioning(item: any) {
    return item.provisioningsts == null || item.provisioningsts == 0;
  }

  isSuspend(item: any) {
    return item.provisioningsts == 2;
  }

  onActionClick(act: any, item: any) {
    this.alert_act = act;
    console.log(act);

    if (act == "manage") {
      this.clearForm();
      this.itemselect = item;
    }
  }

  onReActivation(item: any) {
    if (!confirm("Yakin Re akftifkan ?")) {
      return;
    }

    return this.partnerService
      .PostUnSubscription({
        UserID: item.macaddress,
        Login_name: item.macaddress,
        id: item.id,
      })
      .subscribe((output: {}) => {
        if (output["status"]) {
          //this.loadPartner();
        } else {
          alert(output["msg"]);
        }
      });
  }

  onActivation(item: any) {
    if (!confirm("Yakin akftifkan STB ?")) {
      return;
    }

    return this.partnerService
      .PostSubscription({
        UserID: item.macaddress,
        Login_name: item.macaddress,
        id: item.id,
      })
      .subscribe((output: any) => {
        console.log(output);

        if (output["status"]) {
          // this.loadPartner();
        } else {
          alert(output["msg"]);
        }
      });
  }

  onSuspend(item: any) {
    if (!confirm("Yakin suspend ?")) {
      return;
    }

    return this.partnerService
      .PostSuspend({
        UserID: item.macaddress,
        Login_name: item.macaddress,
        id: item.id,
      })
      .subscribe((output: {}) => {
        if (output["status"]) {
          //this.loadPartner();
        } else {
          alert(output["msg"]);
        }
      });
  }

  onTermination(item: any) {
    if (!confirm("Yakin Terminate ? Customer otomatis not active")) {
      return;
    }

    return this.partnerService
      .PostUnSubscription({
        UserID: item.macaddress,
        Login_name: item.macaddress,
        id: item.id,
      })
      .subscribe((output: any) => {
        if (output["status"]) {
          //this.loadPartner();
        } else {
          alert(output["msg"]);
        }
      });
  }

  onReconnect(item: any) {
    if (!confirm("Yakin Reconnect?")) {
      return;
    }

    return this.partnerService
      .PostReconnect({
        UserID: item.macaddress,
        Login_name: item.macaddress,
        id: item.id,
      })
      .subscribe((output: any) => {
        if (output["status"]) {
          //this.loadPartner();
        } else {
          alert(output["msg"]);
        }
      });
  }

  // Issues list
  loadPartner(params: any) {
    this.table_load = true;
    return this.partnerService
      .GetListNextsysPartner(params)
      .subscribe((output: any) => {
        console.log(output);

        this.table_load = false;

        this.PartnerList = output.data;
        this.paging = output.pagex;
        this.page_self = output.pagex.self;
        this.page_next = output.pagex.next;
        this.page_prev = output.pagex.prev;
        this.meta = output.meta;
        this.total_count = this.meta["totalCount"];
        let self = this.page_self["page"];
        if (self * this.meta["perPage"] < this.meta["totalCount"]) {
          this.last_index = self * this.meta["perPage"];
        } else {
          this.last_index = this.meta["totalCount"];
        }

        this.first_index = (self - 1) * this.meta["perPage"] + 1;

        console.log(this.paging);
        //this.paging_link = this.PartnerList.paging.links;
      });
  }

  search() {
    this.querySearch = true;
    this.searchQueryParams = this.queryParams + "&search=" + this.msearch;
    this.loadPartner(this.searchQueryParams);
  }

  queryStrSearch() {
    if (this.msearch) {
      return "&search=" + this.msearch;
    } else {
      return "";
    }
  }

  submitManageby(data: any, el: HTMLElement) {
    const partnervalue = {
      manageby: this.formSelect.get("manageby").value,
      note: this.formSelect.get("note").value,
    };
    this.partnerService
      .postManageby(data.idcomcorp, partnervalue)
      .subscribe((response: any) => {
        console.log(response);
        if (response.status == true) {
          this.LoadJsOrder.loadScriptProductStb();
          this.alert_success = true;
          this.ngOnInit();

          setTimeout(() => {
            el.scrollIntoView({ behavior: "smooth" });
          }, 500);
          setTimeout(() => {
            this.alert_success = false;
          }, 6000);
        } else {
          this.LoadJsOrder.loadScriptProductStb();
          this.alert_failed = true;
          setTimeout(() => {
            this.alert_failed = false;
          }, 6000);
        }
      });
  }

  submitAddNewPartner(el: HTMLElement) {
    this.alert_success = false;
    this.alert_failed = false;

    console.log(JSON.stringify(this.formAddNewPartner.value));

    this.partnerService
      .PostAddpartnerNextsys(this.formAddNewPartner.value)
      .subscribe((response: any) => {
        console.log(response);
        if (response.status == true) {
          this.LoadJsOrder.loadScriptProductStb();
          this.alert_success = true;

          setTimeout(() => {
            el.scrollIntoView({ behavior: "smooth" });
          }, 500);
          setTimeout(() => {
            this.alert_success = false;
          }, 6000);
        } else {
          this.LoadJsOrder.loadScriptProductStb();
          this.alert_failed = true;
          setTimeout(() => {
            this.alert_failed = false;
          }, 6000);
        }
      });
  }
}
